import { Component, OnInit, Input, Inject } from '@angular/core';
import { IFileStorageService } from 'src/app/core/services/api/contracts/file-storage.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'file-descriptor-preview',
    templateUrl: 'file-descriptor-preview.component.html'
})

export class FileDescriptorPreviewComponent implements OnInit {
    private _fileDescriptorId: string;

    get fileDescriptorId(): string {
        return this._fileDescriptorId;
    }

    @Input()
    set fileDescriptorId(value: string) {
        this._fileDescriptorId = value;
        this.fileDescriptorIdChanged();
    }

    public url: string;

    constructor(@Inject('IFileStorageService') private fileStorageService: IFileStorageService, 
    private sanitizer: DomSanitizer) { }

    ngOnInit() { }

    async fileDescriptorIdChanged() {
        let fileDescriptorBase64: string;
        let fileDescriptorBase64Model = await this.fileStorageService.getBase64(this.fileDescriptorId);
        var blobFront: Blob;

        fileDescriptorBase64 = fileDescriptorBase64Model.base64URL;
        blobFront = this.base64toBlob(fileDescriptorBase64, fileDescriptorBase64Model.fileType);
        this.url = URL.createObjectURL(blobFront);
    }

    base64toBlob(base64Data: string, contentType: string) {
        let base64result = base64Data.split(',')[1];
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64result);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    cleanUrl(url: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}